"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Switch = exports.SwitchBackground = void 0;
const native_1 = __importDefault(require("styled-components/native"));
exports.SwitchBackground = native_1.default.TouchableHighlight `
  display: flex;
  border-radius: 16px;
  background: ${(props) => props.isEnabled
    ? props.theme.switch.enabledTrackColor
    : props.theme.switch.disabledTrackColor};
  width: 58px;
  height: 32px;
  position: relative;
`;
exports.Switch = native_1.default.View `
  border-radius: 16px;
  position: absolute;
  top: 2px;
  width: 28px;
  height: 28px;
  background: ${(props) => props.isEnabled
    ? props.theme.switch.enabledThumbColor
    : props.theme.switch.disabledThumbColor};
`;
